import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, debounceTime,
} from 'rxjs/operators';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import api from '../../api';
import { searchSuccess } from './actions';
import { getSearchQueryParams } from './selectors';


const searchEpic = (action$, $state) => action$.pipe(
  ofType(actionTypes.SEARCH),
  switchMap((action) => api.search.search(
    action.key,
    { ...getSearchQueryParams($state.value), ...action.queryParams },
  ).pipe(
    debounceTime(250),
    mergeMap((response) => [
      searchSuccess(response.body.results, response.body.facets, response.body.sortBy),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


export default combineEpics(searchEpic);
